export default __webpack_public_path__ + "locales/sr-Cyrl-RS/EmptyTrashDialog.json?hash=d1b761761db26ec651c8f308219e38f1";